
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from "react";
import strings from '../../Globalization';
import { CIResultForm } from '../../AppGrid/CIResultTable';
import { useSterilizerCycleInfo } from "./Context";


const CIResultFormDialog = () => {
    const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const { data, combos, ciResultFormDialogOpen, onCloseCIResultFormDialog } = useSterilizerCycleInfo();
    const handleOnSetActiveRecord = (record, opts = { refresh: true }) => {
        if (typeof onCloseCIResultFormDialog === 'function') {
			onCloseCIResultFormDialog(false);
		}
	};
	const handleOnSaveRecord = () => {
		if (typeof onCloseCIResultFormDialog === 'function') {
			onCloseCIResultFormDialog(true);
		}
	};
	
    return (
		<Dialog
			open={ciResultFormDialogOpen}
			onClose={onCloseCIResultFormDialog}
			sx={{ '& .MuiDialog-paper': { minWidth: '60vw' } }}
			fullScreen={fullScreen}
		>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{strings.CIResult}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<CIResultForm
					activeRecord={{record: data, combos}}
					setActiveRecord={handleOnSetActiveRecord}
					containerProps={{ elevation: 0 }}
					onRecordSaved={handleOnSaveRecord}
					disableAlerts
				/>
			</DialogContent>
		</Dialog>
	);
}

export default CIResultFormDialog;